// prettier-ignore
const en = {
    'Sign In': 'Registrarse',
    'Sign Up': 'Regístrate',
    'global.field.empty': 'This field cannot be blank',
    'global.field.invalid': 'Please enter the correct format for this field',

    'create.organization.btn.submit': 'Create',
    'create.organization.msg.required.mailAddress': 'This field cannot be blank',
    //#region System_Msg
    'SYSMSG001': 'A server error occurred. \nPlease contact the administrator.',
    'SYSMSG002': 'Please check your network connection.',
    'SYSMSG003': 'A timeout occurred.',
    //#endregion

    "COMBTN001" : "Cancel",
    "COMBTN002" : "Yes",
    "COMBTN003" : "Apply",
    'COMBTN004' : 'OK',
    "COMBTN006" : "Close",
    "COMBTN009" : "See more",
    'AUTH01MSG10': 'Subdomain does not exist.',

    'COMMSG014': 'This is a required field.',
    'COMMSG034': 'There is no Tag item.',

    'MSG-AI-TOOLTIP-WHEN-OPEN-AI-ON-KNOLEDGE-LIST-PANEL': 'Tooltip when open AI on knowledge list panel',

    // Chat bot
    'CBOTQUOTE01-1': 'AIの回答は正確性を保証するわけではありません。ご留意ください。　',
    'CBOTQUOTE01-2': 'Powered by GPT-4',

    'MSG-AI-ALLOW-ASK-IN-SPOKEN-LANGUAGE': '話し言葉で質問できます',
    "MSG-AI-RESPOND-TO-USER-MSG-ON-PREVIEW-KNOW-ROBO": "Your message has been replied by AI.",
    'MSG-CM-EXCEED-MAX-TEXT-SIZE': 'The total content size exceeds 1MB. Please reduce the content.',
    'MSG-TAG-ITEM-SEARCH-PLACEHOLDER': 'Enter keywords',
    'MSG-TAG-ITEM-SEARCH-ERROR': 'Search failed. Please try again.',
    'ADD_CUSTOMER_PHONE_INVALID': 'The phone number entered is already registered.',

    // AI Settings - Max Knowledge Count
    'TITLE_MAX_AI_CHAT_KNOWLEDGE_COUNT': 'Maximum AI Chat Knowledge Count',
    'LABEL_MAX_AI_CHAT_KNOWLEDGE_COUNT': 'Maximum AI Chat Knowledge Count',
    'MSG-CM-BACK-TO-DEFAULT-MAX-AI-CHAT-KNOWLEDGE-COUNT': 'Reset the maximum AI chat knowledge count to default value. Are you sure?',
    'MSG-AI-INVALID-KNOWLEDGE-BASE-NUMBER': 'Please enter a number between 1 and 1000.',

    // Phone Search V2
    'TAB_HISTORY': 'History',
    'TAB_CONTACTS': 'Contacts',
    'TAB_TRAINING': 'Training',
    'DISPLAY_COUNT': 'Displayed',
    'SEE_MORE': 'See more',
    'RECIPIENT_PROJECT_IN_ORG': 'Projects in Org',
    'RECIPIENT_B2B_CUSTOMER_PROJECT': 'B2B Customer Projects',
    'RECIPIENT_B2B_SUPPORT_PROJECT': 'B2B Support Projects',
    'RECIPIENT_USER_IN_ORG': 'Users in Org',
    'RECIPIENT_PHONE_CALL': 'List phone',

    // Telephone error handling
    'TELEPHONE_AGENT_FUNCTION': 'Telephone Agent Function',
    'TELEPHONE_HOLD_COUNT': 'Hold count',
    'EXTERNAL_PHONE_CALL': 'External Phone Call',
    'TELEPHONE_NUMBER_REQUIRED_FOR_EXTERNAL_CALL': 'A phone number is required for external calls.',
    'DATA_CHANGED_PLEASE_RELOAD_ERROR': 'Data has been changed. Please reload the page.',
    'TEL_INFO_NO_AVAILABLE_RECEIVER': 'No available users to answer. Call cancelled.',
    'TEL_INFO_CALL_ALREADY_IN_PROGRESS': 'This call is already in progress.',
    'TEL_ERR_TARGET_DELETED': 'This call target has been deleted.',
    'INTERNAL_ERROR': 'An internal error occurred. Please try again.',
    'VOICE_CALL_ERROR': 'Voice call failed. Please try again.',
    'TEL_HELD_LABEL': 'Pending',

    'MARKDOWN': 'Markdown',
    'LABEL-TRANSLATION-HISTORY-PAGE-COUNT': 'Pages',
    'LABEL-TRANSLATION-HISTORY-CHAR-COUNT': 'Characters',
    'LABEL-TEXT-TRANSLATION-USAGE': 'Text translation usage',
    'LABEL-TEXT-TRANSLATION-CHAR-COUNT': 'Characters',
    'LABEL-TEXT-TRANSLATION-HISTORY-MODAL-TITLE': 'Text translation usage history',

    // On-demand content translation (ticket / knowledge detail)
    'CM-ONDEMAND-TRANSLATION-TOGGLE-LABEL': 'Translated',
    'CM-ONDEMAND-TRANSLATION-LOADING-TOOLTIP': 'Translating. Please wait a moment.',
    // On-demand chat thread translation (per-message toggle link)
    'CM-ONDEMAND-VIEW-ORIGINAL': 'View original',
    'CM-ONDEMAND-VIEW-TRANSLATION': 'View translation',

    'LABEL_SEARCH_PDF_INCLUDE': 'Include in search',
    'LABEL_SEARCH_PDF_INCLUDED': 'Included in search',
    'LABEL_SEARCH_PDF_EXCLUDE': 'Exclude from search',
    'LABEL_OPEN_FILE_KNOWLEDGE': 'Open file knowledge',

    // K-Board
    'LABEL-FUNCTION-K-BOARD': 'K-Board',
    'ORG-INFOR-LABEL-K-BOARD': 'K-Board',
    'LABEL-K-BOARD-SYSTEM-PROMPT': 'K-Board System Prompt',
    'ORG-INFOR-LABEL-KIBANA-ANALYSIS': 'Analytics Feature',
    'ORG-INFOR-LABEL-KIBANA-ANALYSIS-TOGGLE': 'Use Analytics Feature',

    // App Integration tab
    'TAB_APP_INTEGRATION': 'App Integration',
    'APP_INTEGRATION_AUDIO_DEVICE_SETTING': 'Audio Device Settings',
    'APP_INTEGRATION_CUSTOMER_AUDIO_DEVICE': 'Customer Audio Device',
    'APP_INTEGRATION_USER_AUDIO_DEVICE': 'User Audio Device',
    'APP_INTEGRATION_START': 'Start',
    'APP_INTEGRATION_SELECT_DEVICE_PLACEHOLDER': 'Please select',
    'APP_INTEGRATION_NO_DEVICE': 'No audio devices found',
    'APP_INTEGRATION_MIC_PERMISSION_ERROR': 'Please allow microphone access to use this feature, then close and reopen the tab',
    'APP_INTEGRATION_SAME_DEVICE_ERROR': 'Customer and user devices must be different',
    'APP_INTEGRATION_DEVICE_DISCONNECTED': 'Audio device disconnected. Please select again',
    'APP_INTEGRATION_SESSION_BUSY': 'A call or session is already in progress.',

    // App Integration popup 
    'APP_INTEGRATION_CALL_TITLE': 'App Integration Call',
    'APP_INTEGRATION_SILENCE_WARNING': 'No audio detected. Session will auto-end in 30 seconds.',
    'APP_INTEGRATION_SESSION_ENDED': 'Session ended.',
    'APP_INTEGRATION_STOP': 'Stop',
    'APP_INTEGRATION_CONTINUE': 'Continue',

    // AI Chat Input Group Buttons
    'AI_CHAT_MENU_UPLOAD_FILE': 'File',
    'AI_CHAT_MENU_UPLOAD_IMAGE': 'Image',
    'AI_CHAT_MENU_CAPTURE_IMAGE': 'Camera',
    'AI_CHAT_MENU_MCP_SETTING': 'External Integration Settings',
    'AI_CHAT_MENU_CHAT_AI_SETTING': 'AI Model Settings',
    'AI_CHAT_MENU_REFERENCE_KNOWLEDGE': 'Reference Knowledge',
    'AI_CHAT_MENU_KIBANA_ANALYSIS': 'Analytics',
    'AI_CHAT_MENU_KIBANA_ANALYSIS_REMOVE': 'Remove Analytics',
    'MCP_SERVER_SETTING_FOR_PROJECT': 'Project',
    'MCP_SERVER_SETTING_FOR_PERSONAL': 'Personal',
    'MCP_SERVER_SETTING_TAB_LIST': 'Integration List',
    'MCP_SERVER_SETTING_TAB_PROJECT_LOCAL_MCP': 'Project Local MCP',
    'MCP_SERVER_SETTING_PROJECT_LOCAL_MCP_TITLE': 'Project Local MCP Settings',
    'MCP_SERVER_SETTING_CURRENT_VERSION': 'Current Version',
    'MCP_SERVER_SETTING_INSTALLED_DATE': 'Installed Date',
    'MCP_SERVER_SETTING_BOOTSTRAP_DOWNLOAD': 'Bootstrap Download',
    'AI_CHAT_MENU_AI_LOG_DETAIL': 'Details',
    'AI_CHAT_MENU_CONNECT_KBOARD': 'K-Board Connect',
    'AI_CHAT_KBOARD_CONNECT': 'K-Board Connect',
    'LABEL-KBOARD-PREVIEW': 'K-Board Preview',

    // Replace File
    'LABEL-REPLACE-FILE-TITLE': 'Replace File',
    'LABEL-REPLACE-FILE-CURRENT': 'Current file',
    'LABEL-REPLACE-FILE-SUBMIT': 'Replace',
    'LABEL-REPLACE-FILE-MENU': 'Replace',
    'MSG-REPLACE-FILE-DROP-OR-CLICK': 'Drop a file here or click to select a file',
    'MSG-REPLACE-FILE-EXTENSION-MISMATCH': 'Cannot replace with a different file type. Please select a file with the same format.',
    'MSG-REPLACE-FILE-INFO-BANNER': 'The preview link and file name will be preserved. Only the file content will be replaced with the new content.',
    'MSG-REPLACE-FILE-SELECT-NEW': 'Select new file',
    'MSG-REPLACE-FILE-OR-DRAG': 'or drag & drop',
    'MSG-REPLACE-FILE-UPLOAD-FAILED': 'File upload failed. Please try again.',

    'CM-LOCAL_MCP_CATALOG_MANAGEMENT': "Local MCP Catalog Management",
    'CM-TRANSLATION-MANAGEMENT': "Translation Management",
    'MSG-CM-NO-RESULT-FOUND': 'No matching results were found.',
    'TITLE-LOCAL-MCP-LIST': 'Local MCP list',
    'LABEL-NO-LOCAL-MCP': 'No local MCPs.',
    'BUTTON-ADD-LOCAL-MCP': 'Add local MCP',
    'BUTTON-DELETE-LOCAL-MCP': 'Delete local MCP',
    'MSG-CM-SAVE-LOCAL-MCP-SUCCESS': 'Local MCP has been saved.',
    'MSG-CM-DELETE-LOCAL-MCP-SUCCESS': 'Local MCP has been deleted.',

    // MCP Catalog Form
    'MCP_CATALOG_FORM_TITLE': 'Local MCP Catalog',
    'MCP_CATALOG_FIELD_MCP_NAME': 'MCP Name',
    'MCP_CATALOG_FIELD_PACKAGE_NAME': 'Package Name',
    'MCP_CATALOG_FIELD_PACKAGE_VERSION': 'Package Version',
    'MCP_CATALOG_FIELD_MCP_TYPE': 'MCP Type',
    'MCP_CATALOG_FIELD_REQUIRED_ENV': 'Required Environment Variables',
    'MCP_CATALOG_FIELD_DESCRIPTION': 'Description',
    'MCP_CATALOG_FIELD_PURPOSE': 'Purpose',
    'MCP_CATALOG_FIELD_SUPPORTED_OS': 'Supported OS',
    'MCP_CATALOG_FIELD_DOWNLOAD_URL': 'Download URL',
    'MCP_CATALOG_FIELD_PREREQUISITES': 'Required Software',
    'MCP_CATALOG_FIELD_SYSTEM_PROMPT': 'System Prompt',
    'MCP_CATALOG_FIELD_VERSION': 'Catalog Version',
    'MCP_CATALOG_VERSION_HISTORY_TITLE': 'Version History',
    'MCP_CATALOG_VERSION_COL_VERSION': 'Version',
    'MCP_CATALOG_VERSION_COL_DATE': 'Date',
    'MCP_CATALOG_VERSION_COL_UPDATED_BY': 'Updated By',
    'MCP_ERR_CATALOG_NAME_DUPLICATE': 'This MCP name is already in use.',
    'MCP_ERR_PACKAGE_NAME_DUPLICATE': 'This package name is already in use.',
    'MCP_ERR_PACKAGE_NAME_SPACE': 'Spaces cannot be used in the package name.',
    'MCP_ERR_PACKAGE_VERSION_SPACE': 'Spaces cannot be used.',
    'CM-ROOT-ORGANIZATION-SETTINGS': 'Root organization settings',
    'LOCAL_MCP': "Local MCP",
    // Common concurrent-change reload message
    'COMMSG030': 'The data has been changed. Please reload the page.',

    // MCP-003-F3: Local MCP integration (Bootstrap download)
    'MCP_LOCAL_INTEGRATION_TITLE': 'Local MCP Integration',
    'MCP_LOCAL_CURRENT_VERSION': 'Current version',
    'MCP_LOCAL_INSTALL_DATE': 'Install date',
    'MCP_LOCAL_UPDATE_DATE': 'Release date',
    'MCP_LOCAL_LATEST_VERSION': 'Latest version',
    'MCP_LOCAL_DOWNLOAD_BTN': 'Download',
    'MCP_LOCAL_NOT_DOWNLOADED': 'Not downloaded',
    'MCP_LOCAL_UPDATE_AVAILABLE': 'A new version is available. Please run "Update" in SDESK MCP Agent.',
    'MCP_LOCAL_CATALOG_UPDATE_AVAILABLE': 'The Local MCP configuration has been updated. Please download the latest bootstrap.',
    'MCP_LOCAL_CONNECTION_ERROR': 'Failed to create connection information. Please try again.',
    'MCP_LOCAL_DOWNLOAD_ERROR': 'Failed to create the download file. Please try again.',

    // ST-03: Integration token
    'MCP_TOKEN_TAB': 'Integration Token',
    'MCP_TOKEN_CONNECTION_INFO': 'Connection Info',
    'MCP_TOKEN_CONNECTION_DESCRIPTION': 'Information for connecting to SolutionDesk from an external tool. This value cannot be changed.',
    'MCP_TOKEN_CONNECTION_URL': 'Connection URL',
    'MCP_TOKEN_ACCESS_TOKEN': 'Access Token',
    'MCP_TOKEN_ACCESS_DESCRIPTION': 'This token is for your use only. Use it when connecting an external tool to SolutionDesk. Do not share it with other users.',
    'MCP_TOKEN_X_SD_TOKEN': 'X-SD Token',
    'MCP_TOKEN_CONFIG_SAMPLE': 'Config Sample',
    'MCP_TOKEN_CONFIG_DESCRIPTION': 'Paste this configuration into the configuration file of your external tool.',
    'MCP_TOKEN_COPY': 'Copy',
    'MCP_TOKEN_COPY_ALL': 'Copy All',
    'MCP_TOKEN_COPIED': 'Copied',
    'MCP_TOKEN_COPY_ERROR': 'Copy failed. Please try again.',
    'MCP_TOKEN_SHOW': 'Show token',
    'MCP_TOKEN_HIDE': 'Hide token',
    'MCP_TOKEN_REISSUE': 'Reissue',
    'MCP_TOKEN_REISSUE_MESSAGE_1': 'The current token will be invalidated immediately. If it is in use by an external tool, update that tool with the new token.',
    'MCP_TOKEN_REISSUE_MESSAGE_2': 'This action cannot be undone.',
    'MCP_TOKEN_CANCEL': 'Cancel',
    'MCP_TOKEN_REISSUE_CONFIRM': 'Reissue',
    'MCP_TOKEN_ERROR': 'Failed to load token information. Please try again.',

    // Chatthread message more-menu (BD-3390)
    'MSG-COPY-SHARELINK': 'Link copied.',
    'CHATPOST-MORE-MENU-TOOLTIP': 'More',
    'CHATPOST-COPY-MESSAGE-LINK': 'Copy message link',
    'CHATPOST-COPY-FILE-LINK': 'Copy file link',
};

export default en;
